module.exports = __webpack_public_path__ + "img/trinity_app_yellow.4f84feab.png";